module.exports = __webpack_public_path__ + "img/location-icon.2ad42849c77a9e8d919f5e7efbaac0dd.svg";